import { CurrentCommunityLayoutFragment, RoleAddonFragment } from 'shared/graphql';

/**
 * Checks if the current user's role addons authorize access to the given route.
 *
 * @param route - The route object containing allowed role addons.
 * @param userRoleAddons - The list of role addons assigned to the current user.
 * @returns `true` if the user has at least one role addon matching the route's allowed roles, otherwise `false`.
 */
export function checkRouteAuthorization(
  route: CurrentCommunityLayoutFragment,
  userRoleAddons: RoleAddonFragment[],
): boolean {
  const allowedRoles = route?.roleAddons?.items ?? [];
  return allowedRoles.some(role => userRoleAddons.some(userRole => userRole.id === role.id));
}

/**
 * Filters the provided routes and returns only those that the user is authorized to access
 * based on their assigned role addons.
 *
 * @param communityRoutes - The list of route objects to filter.
 * @param userRoleAddons - The list of role addons assigned to the current user.
 * @returns An array of routes that the user is authorized to access.
 */
export function filterAllowedRoutesForUser(
  communityRoutes: CurrentCommunityLayoutFragment[],
  userRoleAddons: RoleAddonFragment[],
): CurrentCommunityLayoutFragment[] {
  return communityRoutes.filter(route => checkRouteAuthorization(route, userRoleAddons));
}
